// import React, { useState, useEffect, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { IdleTimerProvider } from 'react-idle-timer';
// import { ConfigContext } from '../../Context/ConfigContext';

// const AutoLogout = () => {
//     const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
//     const [isIdle, setIsIdle] = useState(false);
//     const navigate = useNavigate();
//     const idleTimeout = 0.25 * 60 * 1000; // 15 seconds for testing

//     // Logout function
//     const handleLogout = () => {
//         console.log('Logging out due to inactivity.');
//         localStorage.removeItem("token_erp");
//         localStorage.removeItem("user_id_erp");
//         localStorage.removeItem("company_id_erp");
//         localStorage.removeItem('lastActiveErp');
//         // navigate("/"); 
//         window.location.href = '/';
//     };

//     // Reset idle timer and update last activity timestamp
//     const resetIdleTimer = () => {
//         const now = Date.now();
//         localStorage.setItem('lastActiveErp', now);
//         setIsIdle(false);
//         console.log('Idle timer reset. Last active updated to:', new Date(now).toISOString());
//     };
//     useEffect(()=>{
//         const now = Date.now();
//         localStorage.setItem('lastActiveErp', now);
//         setIsIdle(false);
//     },[]);

//     useEffect(() => {
       
//         const storedLastActiveErp = localStorage.getItem('lastActiveErp');
//         const now = Date.now();
//         console.log("storedLastActiveErp ,now, now - parseInt(storedLastActiveErp,10) >= idleTimeout",storedLastActiveErp ,now,now - parseInt(storedLastActiveErp) , idleTimeout);
//         // Initialize `lastActiveErp` if missing
//         if (!storedLastActiveErp) {
//             console.log('No lastActiveErp found. Initializing.');
//             resetIdleTimer();
//         } else if (now - parseInt(storedLastActiveErp) >= idleTimeout) {
//             // If idle timeout is already exceeded
//             console.log('Idle timeout exceeded. Logging out.');
//             setIsIdle(true);
//         } else {
//             console.log('Session is active. Preventing immediate logout.');
//             resetIdleTimer();
//         }

//         // Add event listener for cross-tab synchronization
//         const syncLastActiveErp = (e) => {
//             if (e.key === 'lastActiveErp') {
//                 console.log('Detected activity in another tab. Resetting idle timer.');
//                 resetIdleTimer();
//             }
//         };

//         window.addEventListener('storage', syncLastActiveErp);

//         return () => {
//             window.removeEventListener('storage', syncLastActiveErp);
//         };
//     }, []);
//     console.log("Outside",isIdle);
//     useEffect(() => {

//         console.log("useEffect",isIdle);
//         if (isIdle) {
//             handleLogout();
//         }
//     }, [isIdle]);

//     return (
//         <IdleTimerProvider
//             timeout={idleTimeout}
//             onIdle={() => setIsIdle(true)}
//             onActive={resetIdleTimer}
//             debounce={500}
//         >
//             {null}
//         </IdleTimerProvider>
//     );
// };

// export default AutoLogout;
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { IdleTimerProvider } from 'react-idle-timer';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';

const AutoLogout = () => {
    const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
    const [isIdle, setIsIdle] = useState(false);
    const navigate = useNavigate();
    const idleTimeout = 30 * 60 * 1000; // 30 minutes

    // Logout function
    const handleLogout = () => {
        console.log('Logging out due to inactivity or browser close.');
        localStorage.removeItem("token_erp");
        localStorage.removeItem("user_id_erp");
        localStorage.removeItem("company_id_erp");
        window.location.href = '/';
    };
    useEffect(()=>{
        const now = Date.now();
        localStorage.setItem('lastActiveErp', now);
        setIsIdle(false);
    },[]);
    // Function to reset idle timer and update last active timestamp
    const resetIdleTimer = () => {
        localStorage.setItem('lastActiveErp', Date.now()); // Sync across tabs
        setIsIdle(false); // Reset idle state
    };

    // Sync the last active time across tabs using localStorage
    const syncLastActiveErp = () => {
        const storedLastActiveErp = localStorage.getItem('lastActiveErp');
        if (storedLastActiveErp) {
            resetIdleTimer(); // Reset idle state if activity is detected
        } else {
            console.warn('No lastActiveErp found. Skipping sync for fresh session.');
        }
    };
    useEffect(() => {
        // On fresh load, initialize lastActiveErp if missing
        const storedLastActiveErp = localStorage.getItem('lastActiveErp');
        if (!storedLastActiveErp) {
            localStorage.setItem('lastActiveErp', Date.now()); // Initialize
        }
    
        // Add event listener for cross-tab synchronization
        window.addEventListener('storage', syncLastActiveErp);
    
        return () => {
            window.removeEventListener('storage', syncLastActiveErp);
        };
    }, []);
    useEffect(() => {
        const token = localStorage.getItem("token_erp");
        if (!token) {
            setIsIdle(true); // Trigger idle if no token exists
            return;
        }
    
        const now = Date.now();
        const storedLastActiveErp = localStorage.getItem('lastActiveErp');
    
        // Prevent immediate logout on fresh load
        if (!storedLastActiveErp || now - storedLastActiveErp < idleTimeout) {
            console.log('Session is active, preventing immediate logout.');
            resetIdleTimer();
        } else {
            setIsIdle(true);
        }
    }, []);
    
    useEffect(() => {
    const sessionKey = 'session_active_erp';

    // Check and initialize session status
    if (!sessionStorage.getItem(sessionKey)) {
        sessionStorage.setItem(sessionKey, 'true'); // Set session as active
    }

    // Handle visibility changes for refresh scenarios
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            sessionStorage.setItem('refresh_flag_erp', 'true');
        } else {
            sessionStorage.removeItem('refresh_flag_erp');
        }
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
        window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
}, []);



    // Fetch regularization settings and handle token expiration
    useEffect(() => {
        const sessionKey = 'session_active_erp';
    
        // Check and initialize session status
        if (!sessionStorage.getItem(sessionKey)) {
            sessionStorage.setItem(sessionKey, 'true'); // Set session as active
        }
    
        // Handle visibility changes for refresh scenarios
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                sessionStorage.setItem('refresh_flag_erp', 'true');
            } else {
                sessionStorage.removeItem('refresh_flag_erp');
            }
        };
    
        window.addEventListener('visibilitychange', handleVisibilityChange);
    
        return () => {
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const getList = () => {
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}MailMaster/GetMailTemplateList`, { headers })
            .then(response => {
                const { success, message } = response.data;
                if (success === false && message === 'This token has been expired.') {
                    console.log('Token has expired, triggering idle state.');
                    setIsIdle(true); 
                }
            })
            .catch(error => {
                console.error('Error fetching GetMailTemplateList in AutoLogout:', error);
            });
    };

    useEffect(() => {
        if (isIdle) {
            handleLogout();
        }
    }, [isIdle]);

    useEffect(() => {
        getList();
    }, []);

    return (
        <IdleTimerProvider
            timeout={idleTimeout}
            onIdle={() => setIsIdle(true)}
            onActive={resetIdleTimer}
            debounce={500} 
        >
            {null}
        </IdleTimerProvider>
    );
};

export default AutoLogout;